export const alertStatusFaqContent = {
  "In progress": {
    text: "Alert received and pending processing. No action required."
  },
  "Auto-refunded": {
    text: "Auto-refund successful. No action needed.",
    linkText: "About this status",
    link: "https://help.chargeback.io/en/articles/12782874-meanings-of-alert-statuses"
  },
  "Manually refunded": {
    text: "This alert has been marked as refunded — manually or via a pre-refunded transaction. No action needed.",
    linkText: "About this status",
    link: "https://help.chargeback.io/en/articles/12782874-meanings-of-alert-statuses"
  },
  Attention: {
    text: "Auto-refund failed. Issue a manual refund before this alert expires.",
    linkText: "Transaction lookup guide",
    link: "https://help.chargeback.io/en/articles/12782825-how-to-locate-transactions-with-attention-chargeback-alerts"
  },
  Expired: {
    text: "This alert expired before a refund was issued. If the transaction doesn't exist in your processor, file a credit request.",
    linkText: "Credit request guide",
    link: "https://help.chargeback.io/en/articles/12782870-requesting-manual-credits-for-alerts"
  },
  Canceled: {
    text: "The merchant canceled the refund request. No further action required."
  },
  Declined: {
    text: "This transaction didn't meet the criteria for an auto-refund under your account rules. Review your settings to adjust auto-refund criteria.",
    linkText: "Auto-refund setup guide",
    link: "https://help.chargeback.io/en/articles/12782819-setting-up-manual-automatic-refunds"
  },
  "Not found": {
    text: "You couldn't locate a matching transaction in your processor. If you haven't already, file a credit request.",
    linkText: "Credit request guide",
    link: "https://help.chargeback.io/en/articles/12782870-requesting-manual-credits-for-alerts"
  },
  "Failed transaction": {
    text: "This transaction failed or was unauthorized, so no refund was issued.",
    linkText: "What to do next",
    link: "https://help.chargeback.io/en/articles/14191660-failed-transaction-alert-error-status-what-to-do"
  },
  "Previously refunded": {
    text: "This transaction was already refunded through your processor before the alert was received.",
    linkText: "What to do next",
    link: "https://help.chargeback.io/en/articles/14190174-previously-refunded-alert-error-status-what-to-do"
  },
  "Already a chargeback": {
    text: "This transaction was already a chargeback before the alert was received.",
    linkText: "What to do next",
    link: "https://help.chargeback.io/en/articles/14191626-already-a-chargeback-alert-error-status-what-to-do"
  },
  Duplicate: {
    text: "This alert is a duplicate of a previously received alert. A credit request has been automatically issued and approved.",
    linkText: "Credit details",
    link: "open_credit_request"
  },
  Error: {
    text: "An error has occurred. Contact support for assistance."
  },
  Pending: null // TODO: add FAQ content for the "Pending" status
}
